// extracted by mini-css-extract-plugin
export default {"wrapper":"HKtQq_vHDlMPZf0vdQlh","tabs":"nKQOcPwOchsqoHUO4Rw1"};